import React, { useEffect, useState } from 'react';
import makeStyles from '@mui/styles/makeStyles';
import createStyles from '@mui/styles/createStyles';
import {
    Theme,
    ListItem,
    ListItemText,
    ListItemIcon,
    Divider,
} from '@mui/material';
import { Alert } from 'models/alerts';
import { LooksOne, LooksTwo, Looks3 } from '@mui/icons-material';
import ErrorOutlineRoundedIcon from '@mui/icons-material/ErrorOutlineRounded';
import { useAppSelector } from 'hooks';

const useStyles = makeStyles((theme: Theme) =>
    createStyles({
        root: {
            width: '100%',
            paddingRight: theme.spacing(2),
        },
        nested: {
            paddingLeft: theme.spacing(4),
        },
        selected: {
            backgroundColor: theme.palette.secondary.light,
        },
    }),
);

interface ListItemProps {
    alert: Alert;
    onClick?: () => void;
}

const AlertListItem: React.FunctionComponent<ListItemProps> = ({
    alert,
    onClick,
}) => {
    const classes = useStyles();

    const { alertDetails } = useAppSelector((root) => root.alerts);

    const [alertSelected, setAlertSelected] = useState(
        alertDetails.status !== 'idle' && alert.id === alertDetails.object?.id,
    );

    //reset alertSelected to false when component is mounted

    useEffect(() => {
        setAlertSelected(false);
    }, []);

    let icon: React.ReactNode;

    if (alert.level === 1) {
        icon = <LooksOne fontSize="medium" style={{ color: 'lightBlue' }} />;
    }
    if (alert.level === 2) {
        icon = <LooksTwo fontSize="medium" style={{ color: 'orange' }} />;
    }
    if (alert.level === 3) {
        icon = <Looks3 fontSize="medium" style={{ color: 'red' }} />;
    }

    return (
        <div>
            <ListItem
                button
                className={
                    alertSelected
                        ? `${classes.root} ${classes.selected}`
                        : classes.root
                }
                onClick={() => onClick && onClick()}
            >
                <ListItemIcon>
                    <ErrorOutlineRoundedIcon
                        style={{ color: alert.acknowledged ? 'grey' : 'red' }}
                        fontSize="large"
                    />
                </ListItemIcon>
                <ListItemText
                    primary={alert.type?.toUpperCase()}
                    secondary={alert.created?.toUTCString()}
                />
                Level :<ListItemIcon>{icon}</ListItemIcon>
            </ListItem>
            <Divider />
        </div>
    );
};

AlertListItem.displayName = 'AlertListItem';
export default AlertListItem;
